<div class="table-info-widget-container">
  <mat-card class="table-info-widget">
    <mat-card-header>
      <mat-card-title
        >Text Conversations Database Table Information</mat-card-title
      >
    </mat-card-header>

    <mat-card-content>
      @if (data && data.tableInfo) {
        <div class="info-grid">
          <div class="info-item">
            <mat-icon class="info-icon">event</mat-icon>
            <div class="info-content">
              <span class="info-label">Created</span>
              <span class="info-value">{{
                formatDate(data.tableInfo.creationDateTime)
              }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">storage</mat-icon>
            <div class="info-content">
              <span class="info-label">Table Size</span>
              <span class="info-value">{{
                formatBytes(data.tableSizeBytes)
              }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon
              [class]="'info-icon status-' + getStatusColor(data.tableStatus)"
            >
              {{ getStatusIcon(data.tableStatus) }}
            </mat-icon>
            <div class="info-content">
              <span class="info-label">Status</span>
              <span
                class="info-value status"
                [class]="'status-' + getStatusColor(data.tableStatus)"
              >
                {{ data.tableStatus }}
              </span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">list</mat-icon>
            <div class="info-content">
              <span class="info-label">Total Items</span>
              <span class="info-value">{{ data.totalItems | number }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div class="no-data">
          <mat-icon>info</mat-icon>
          <span>No table information available</span>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>

<!--TODO: do we need a info widget for the v2v table too?-->
